// ด่านแบบประเมินก่อนสมัครงาน — ถาม server ว่าต้องทำก่อนไหม (เดิมเก็บใน localStorage — เลิกใช้แล้ว 2026-09-29)
// server เป็นคนตัดสินเสมอ: ยื่นใบสมัครโดยไม่ผ่านด่านนี้ API ก็ตอบ 403 PRE_ASSESSMENT_REQUIRED อยู่ดี
import { getPreAssessment } from '@/services/assessmentService'

// ต้องทำแบบประเมินก่อนสมัครงานไหม — เฉพาะบัญชี INDIVIDUAL, แบบประเมินเปิดอยู่ และยังไม่ได้ส่ง
// เรียก API ไม่สำเร็จ → ไม่บล็อก (backend ยังกันไว้อีกชั้นตอนยื่นใบสมัคร)
export async function needsPreAssessment(customerType: string | null): Promise<boolean> {
  if (customerType !== 'INDIVIDUAL') return false
  try {
    return (await getPreAssessment()).required
  } catch {
    return false
  }
}

// path หน้าแบบประเมิน พร้อม returnTo ให้กลับมาหน้าสมัครงานเดิมหลังส่งเสร็จ
export function preAssessmentPath(returnTo: string): string {
  return `/pre-assessment?returnTo=${encodeURIComponent(returnTo)}`
}
